<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <a-form :form="form" class="search-all-box">
        <!-- 实践活动名称 -->
        <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="实践活动名称：">
          <a-input class="search-input" v-decorator="rules.name" placeholder="请输入实践活动名称" />
        </a-form-item>
        <!-- 实践学期 -->
        <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="实践学期：">
          <a-select class="multiple-select" dropdownClassName="multipleDrop" placeholder="请选择实践学期" v-decorator="rules.semester">
            <a-select-option :value="item.key" v-for="(item, index) in activityTerm" :key="index">
              {{ item.value }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <!-- 实践课程 -->
        <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="实践课程">
          <a-radio-group v-decorator="rules.course">
            <div class="radio-item" v-for="item,index in trainCourse" :key="index" @click="setFieldsValue('course',item.id)">
              <div class="radio-cover">
                <div class="cover-img" :style="`background:url(${item.cover})no-repeat center/cover`"></div>
              </div>
              <div class="radio-name">{{ item.name }}</div>
              <a-radio :value="item.id"></a-radio>
            </div>
          </a-radio-group>
        </a-form-item>
        <!-- 负责教师 -->
        <a-form-item :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol" label="负责教师">
          <div class="filter-box">
            <div class="filter-content">
              <div class="con-first">
                <a-select v-decorator="rules.teacher" show-search :allowClear="true" mode="multiple" placeholder="输入教师姓名、账号查询" option-filter-prop="children" :filter-option="filterOption" class="multiple-select" dropdownClassName="multipleDrop"
                  @change="handleChange">
                  <a-select-option v-for="(item, index) in teacherArr" :key="index" :value="item.id" :name="item.name" :username="item.username">{{ item.name }} <span class="right-txt">{{ item.username }}</span></a-select-option>
                </a-select>
              </div>
              <div class="con-second" v-if="selectedTeacherList && selectedTeacherList.length > 0">
                <div class="address-item" v-for="item,index in selectedTeacherList" :key="index">
                  {{ item.name }}&nbsp;&nbsp;{{ item.username }} <span class="del-icon" @click="removeSelectedTeacher(item.id)"></span>
                </div>
              </div>
            </div>
          </div>
        </a-form-item>
        <!-- 活动状态 -->
        <a-form-item :label-col="formItemLayout.labelCol" v-decorator="rules.status" :wrapper-col="formItemLayout.wrapperCol" label="活动状态：">
          <div class="status-box">
            <a-radio-group v-decorator="rules.status">
              <a-radio :value="item.id" v-for="item,index in statusArr" :key="index">{{ item.name }}</a-radio>
            </a-radio-group>
          </div>
          <div class="status-tip">设置结课后，学生将无法再参加该场实践活动</div>
        </a-form-item>

        <!-- check -->
        <a-form-item :label-col="formTailLayout.labelCol" :wrapper-col="formTailLayout.wrapperCol">
          <div class="eol-button-group">
            <div class="eol-button button-cancel" @click="cancelClick()">取 消</div>
            <div class="eol-button button-confirm" @click="check">确 认</div>
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 9 },
};
const formTailLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 9, offset: 3 },
};
import Bread from "../../../components/school/Bread.vue"
import services from "../../../assets/js/services";
import { mapState, mapActions } from "vuex";
export default {
  name: "TeachCreate",
  data () {
    return {
      breadConfig: [
        { name: "实践教学活动" },
        { name: "活动管理" },
      ],
      school_code: localStorage.getItem("schoolCode"),
      formItemLayout,
      formTailLayout,
      form: this.$form.createForm(this, { name: 'dynamic_rule' }),
      rules: {
        name: [
          "name",
          {
            validateTrigger: "blur",
            rules: [
              { required: true, whitespace: true, message: "请输入实践活动名称" },
              { min: 2, whitespace: true, message: "实践活动名称最少输入2个字符" },
              {
                max: 100,
                whitespace: true,
                message: "实践活动名称不能超过100个字符",
              },
            ],
          },
        ],
        semester: [
          "semester",
          {
            rules: [{ required: true, message: "请选择实践学期" }],
          },
        ],
        course: [
          "course",
          {
            rules: [{ required: true, message: "请选择实践课程" }],
          },
        ],
        teacher: [
          "teacher",
          {
            rules: [{ required: true, message: "请选择负责教师" }],
          },
        ],
        status: [
          "status",
          {
            rules: [{ required: true, message: "请选择活动状态" }],
          },
        ]
      },
      teacherArr: [],
      statusArr: [
        { id: 1, name: "开课" },
        { id: 2, name: "结课", }
      ],
      selectedTeacherList: [],
      id: ""
    }
  },
  computed: {
    ...mapState({
      activityTerm: state => state.teachEvent.activityTerm,
      trainCourse: state => state.teachEvent.trainCourse,
      activityInfo: (state) => state.activityStat.activityInfo,
    }),

  },
  components: {
    Bread
  },
  async mounted () {
    this.id = this.$route.query.id
    // 状态默认选中开课
    await this.setFieldsValue("status", this.statusArr[0].id)
    // 获取学期数据
    await this.getActivityTerm()
    // 获取实验课程
    await this.getTrainCourse()
    // 获取教师列表
    await this.getTeacherList()
    // 获取活动详情
    await this.getDetail()
  },
  methods: {
    ...mapActions(["getActivityTerm", "getTrainCourse", "getSchoolManageUser", 'getSchoolActivityDetail']),
    removeSelectedTeacher (id) {
      const index = this.selectedTeacherList.findIndex(item => item.id == id);
      this.selectedTeacherList.splice(index, 1)
      const teacher = this.selectedTeacherList.map(item => item.id);
      this.form.setFieldsValue({ teacher }); // 更新表单值
    },
    async getDetail () {
      // let result = this.activityInfo
      let result = {}
      result["data"] = this.activityInfo
      // if (!this.activityInfo) {
      // let result = await this.getSchoolActivityDetail({ id: this.id })
      // if (result.code == "0000") {
      let teacher_ids = result.data.teacher_ids
      teacher_ids.forEach((item, index) => {
        teacher_ids[index] = Number(teacher_ids[index])
      })
      this.form.setFieldsValue({ name: result.data.name, status: result.data.status, course: result.data.course_id, semester: `${result.data.year}-${result.data.term}`, teacher: result.data.teacher_ids })
      this.handleChange(result.data.teacher_ids)
      // }
      // }
    },
    async getTeacherList () {
      let params = {
        page: 1,
        size: 999,
        role_ids: '1,2', // 1老师 2管理员
      };
      await this.getSchoolManageUser(params).then((res) => {
        if (res.code == "0000" && res.data) {
          this.teacherArr = res.data.items;
        }
      });
    },
    check () {
      this.form.validateFields(async err => {
        if (!err) {
          let params = this.form.getFieldsValue()
          let result = await services.updateSchoolActivity({ id: this.id, name: params.name, term: params.semester, status: params.status, course_id: params.course, teacher_ids: params.teacher.join(","), _method: "put" })
          if (result.code == "0000") {
            this.$message.success("保存成功")
            this.getSchoolActivityDetail({ id: this.id })
          } else {
            this.$message.error(result.message)
          }
        }
      });
    },
    setFieldsValue (key, id) {
      this.form.setFieldsValue({ [key]: id });
    },
    cancelClick () {
      this.$router.push(`/${this.school_code}/school/teach`)
    },
    handleChange (arr) {
      // 过滤选中的教师
      const selectedTeachers = this.teacherArr.filter((item) => arr.includes(item.id));
      if (selectedTeachers && selectedTeachers.length) {
        this.selectedTeacherList = arr.map(id => selectedTeachers.find(teacher => teacher.id == id)); // 排序
      } else {
        this.setFieldsValue("teacher", [])
      }
    },
    filterOption (input, option) {
      const name = option.data.attrs.name || "";
      const username = option.data.attrs.username || "";
      return (
        name.toLowerCase().includes(input.toLowerCase()) ||
        username.toLowerCase().includes(input.toLowerCase())
      );
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-form-item-children,
/deep/ .ant-radio-group {
    display: block;
    width: 100%;
}

/deep/ .ant-radio-wrapper {
    margin-right: 0;
    .ant-radio {
        .ant-radio-inner {
            transition: all 0s;
            width: 16px;
            height: 16px;
            background: url('../../../assets/image/school/teach/radio.png')
                no-repeat center/cover;
            border: none;
            box-shadow: none;
            &::after {
                display: none;
            }
        }
    }
    &.ant-radio-wrapper-checked {
        display: block;
        margin-right: -2px;
        .ant-radio {
            .ant-radio-inner {
                width: 20px;
                height: 20px;
                background: url('../../../assets/image/school/teach/radio-active.png')
                    no-repeat center/cover;
            }
            &.ant-radio-checked::after {
                border-color: #bd2b24;
            }
        }
    }
}

.radio-item {
    width: 100%;
    height: 75px;
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    background: #ffffff;
    transition: all 0.3s;
    &:has(.ant-radio-wrapper-checked),
    &:hover {
        background: #fff3f2;
    }
    pointer-events: none;
    .radio-cover,
    .radio-name {
        opacity: 0.5;
    }
    &:has(.ant-radio-wrapper-checked) .radio-cover,
    &:has(.ant-radio-wrapper-checked) .radio-name {
        opacity: 1;
        background: #fff3f2;
    }
    .radio-name {
        background: #f8f8f8;
    }
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 5px;
    }
    &:hover {
        .radio-cover {
            .cover-img {
                transform: scale(1.1);
            }
        }
    }
    .radio-cover {
        width: 100px;
        height: 100%;
        overflow: hidden;
        .cover-img {
            width: 100%;
            height: 100%;
            transition: all 0.3s;
        }
    }
    .radio-name {
        flex: 1;
        height: 100%;
        border: 1px solid #ececec;
        border-left: none;
        padding: 0 30px;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #333132;
        line-height: 24px;
    }
    .ant-radio-wrapper {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
    }
}

.eol-button-group {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .eol-button {
        height: 32px;
        text-align: center;
        line-height: 32px;
        cursor: pointer;
        font-size: 14px;
        padding: 0 22px;
        &:not(:last-child) {
            margin-right: 14px;
        }
        &.button-cancel {
            background: #ecedef;
            color: #333333;
        }
        &.button-confirm {
            background: #a82822;
            color: #ffffff;
        }
    }
}

.filter-box {
    display: flex;
    padding: 0 0 8px;
    .filter-label {
        font-weight: 400;
        font-size: 14px;
        color: #373536;
        line-height: 30px;
    }
    .filter-content {
        flex: 1;
        .judge-list {
            display: block;
            margin-bottom: 10px;
            .judge-item {
                cursor: pointer;
                display: inline-block;
                margin-right: 15px;
                width: 122px;
                height: 32px;
                line-height: 30px;
                background: #ffffff;
                border-radius: 16px;
                border: 1px solid #dbdad8;
                font-size: 14px;
                text-align: center;
                color: #373536;
                &:hover,
                &.active {
                    color: #a82822;
                    background: #fff3f2;
                    border: 1px solid #cc9d9a;
                }
                &::before {
                    content: '';
                    display: inline-block;
                    margin-right: 10px;
                    width: 14px;
                    height: 14px;
                    background: url('../../../assets/image/student/stepFour/unitFour/icon.png')
                        no-repeat center;
                    background-size: cover;
                    vertical-align: -2px;
                }
                &.active::before {
                    background: url('../../../assets/image/student/stepFour/unitFour/icon-active.png')
                        no-repeat center;
                    background-size: cover;
                }
            }
        }
        .multiple-select {
            /deep/ .ant-select-selection-selected-value {
                font-weight: bold;
                font-size: 14px;
                color: #8b3c22;
            }
            /deep/ .ant-select-selection {
                min-height: 32px;
                border-radius: 0;
                line-height: 32px;
                border-color: #dbdad8 !important;
                border-right-width: 1px !important;
                box-shadow: none !important;
            }
            /deep/ .ant-select-selection__placeholder,
            .ant-select-search__field__placeholder {
                color: #7e8287;
            }
            /deep/ .ant-select-focused .ant-select-selection,
            /deep/ .ant-select-selection:focus,
            /deep/ .ant-select-selection:active,
            /deep/ .ant-select-selection:hover {
                border-color: #dbdad8 !important;
                border-right-width: 1px !important;
                box-shadow: none !important;
            }
            /deep/ .ant-select-selection__choice {
                background: #f4f3f3;
                border-radius: 14px;
                padding: 0 22px 0 12px;
            }
            /deep/
                .ant-select-selection--multiple
                .ant-select-selection__choice__remove:hover {
                color: #8b3c22;
            }
            /deep/ .ant-select-arrow {
                width: 9px;
                height: 8px;
                margin-top: -4px;
                background-image: url('../../../assets/image/student/stepFour/unitThree/down-default.png');
            }
            &.ant-select-open /deep/ .ant-select-arrow {
                background-image: url('../../../assets/image/student/stepFour/unitThree/down.png');
            }
        }
        .con-second {
            background: #f9f9f9;
            padding: 12px 13px 0;
            .address-item {
                display: inline-block;
                line-height: 29px;
                height: 29px;
                background: #ecedef;
                border-radius: 15px;
                margin-right: 10px;
                font-weight: 400;
                font-size: 14px;
                color: #494e57;
                padding: 0 15px;
                margin-bottom: 12px;
                .del-icon {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    margin-left: 10px;
                    background-image: url('../../../assets/image/student/stepFour/unitThree/del.png') !important;
                    background-size: cover;
                    vertical-align: -1px;
                    cursor: pointer;
                    &:hover {
                        background-image: url('../../../assets/image/student/stepFour/unitThree/del-hover.png') !important;
                        background-size: cover;
                    }
                }
            }
        }
    }
}
.status-box {
    height: 38px;
    display: flex;
    align-items: center;
    .ant-radio-group {
        display: flex;
        align-items: center;
        .ant-radio-wrapper {
            width: 122px;
            height: 32px;
            background: #ffffff;
            border-radius: 16px;
            border: 1px solid #dbdad8;
            line-height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:not(:last-child) {
                margin-right: 12px;
            }
            &:hover,
            &.ant-radio-wrapper-checked {
                background: #fff3f2;
                border: 1px solid #cc9d9a;
            }
        }
    }
}
.status-tip {
    display: inline-block;
    height: 26px;
    background: #fffbf5;
    line-height: 26px;
    padding: 0 10px;
    font-size: 14px;
    color: #d88d45;
    margin-top: 7px;
}
/deep/ .ant-form-item-control {
    position: relative;
    &.has-error {
        &::after {
            content: '';
            display: inline-block;
            position: absolute;
            top: 12px;
            right: -24px;
            width: 14px;
            height: 14px;
            background: url('../../../assets/image/school/teach/error.png')
                no-repeat center/cover;
        }
    }
}
.multiple-select {
    /deep/ .ant-select-selection-selected-value {
        font-weight: bold;
        font-size: 14px;
        color: #8b3c22;
    }
    /deep/ .ant-select-selection {
        min-height: 32px;
        border-radius: 0;
        line-height: 32px;
        border-color: #dbdad8 !important;
        border-right-width: 1px !important;
        box-shadow: none !important;
    }
    /deep/ .ant-select-selection__placeholder,
    .ant-select-search__field__placeholder {
        color: #7e8287;
    }
    /deep/ .ant-select-focused .ant-select-selection,
    /deep/ .ant-select-selection:focus,
    /deep/ .ant-select-selection:active,
    /deep/ .ant-select-selection:hover {
        border-color: #dbdad8 !important;
        border-right-width: 1px !important;
        box-shadow: none !important;
    }
    /deep/ .ant-select-selection__choice {
        background: #f4f3f3;
        border-radius: 14px;
        padding: 0 22px 0 12px;
    }
    /deep/
        .ant-select-selection--multiple
        .ant-select-selection__choice__remove:hover {
        color: #8b3c22;
    }
    /deep/ .ant-select-arrow {
        width: 9px;
        height: 8px;
        margin-top: -4px;
        background-image: url('../../../assets/image/student/stepFour/unitThree/down-default.png');
    }
    &.ant-select-open /deep/ .ant-select-arrow {
        background-image: url('../../../assets/image/student/stepFour/unitThree/down.png');
    }
}
.search-all-box {
    display: block;
}
.eol-bread-box {
    padding-top: 0;
}
</style>
